import type { PartnerConfig } from "@/content/partners/types"

export const MERCADO_NOVO_PARTNER_SLUG = "mercado-novo"

/** PNG oficial (343×108, fundo transparente). A versão vetorial entra depois no mesmo lugar. */
export const MERCADO_NOVO_LOGO_PATH = "/partners/mercado-novo/logo.png"

/** Laranja e marrom do logo. Só kicker e anel; CTAs ficam Action-Blue. */
export const mercadoNovoBrand = {
  accent: "#FF4B1C",
  accentDark: "#522925",
  accentLight: "#FF4B1C",
  navy: "#002a50",
  ringFrom: "#FF4B1C",
  ringTo: "#522925",
  benefit: "#522925",
  benefitForeground: "#FFFFFF",
} as const

export const mercadoNovoPartnerConfig: PartnerConfig = {
  slug: MERCADO_NOVO_PARTNER_SLUG,
  name: "Mercado Novo",
  fullName: "Mercado Novo",
  logoPath: MERCADO_NOVO_LOGO_PATH,
  benefitMode: "percent_increment",
  benefitPercentIncrement: 3,
  isActive: true,
  metadata: {
    industry: "mercado",
    audience: "clientes_do_mercado",
  },
}

export const mercadoNovoPartnerContent = {
  ...mercadoNovoPartnerConfig,
  tagline: "Mercado Novo",
  benefitHeadline: "Benefício para clientes do Mercado Novo",
  heroHeadline: "Clientes do Mercado Novo têm desconto extra na energia",
  heroSubtitle:
    "Economize até 28% do total da sua conta de luz com a energia solar por assinatura da Astra.",
  partnershipIntro:
    "Clientes do Mercado Novo têm 3% a mais de desconto por assinar pelo link do Mercado Novo. Cadastro simples, benefício automático por este link.",
  partnershipTitle: "Mercado Novo e energia limpa, juntos",
} as const
